/**
 * The shared data grid: one <DataTable> used across ~50 screens, plus the
 * footer, bulk-action bar, column-resize helpers and client-side pagination
 * hook that belong to it.
 *
 * Deliberately separate from the Tables *product feature* (TableTool),
 * which is a different thing that happens to also render a table.
 */
export { DataTable, HoverPrefetchLink } from "./DataTable";
export type { BulkAction } from "./DataTable";
export { TableControlsFooter } from "./TableControlsFooter";
export type { TableControlsFooterProps } from "./TableControlsFooter";
export { useClientPagination } from "./useClientPagination";
